const EMPTY_RICH_TEXT_PATTERN = /^<p>\s*<br\s*\/?>\s*<\/p>$/i;

export const isEmptyRichText = (value?: string | null): boolean => {
  const trimmed = value?.trim();

  if (!trimmed) {
    return true;
  }

  return EMPTY_RICH_TEXT_PATTERN.test(trimmed);
};

export const normalizeRichText = (value?: string | null): string | null =>
  isEmptyRichText(value) ? null : (value as string).trim();
